import { ValidationInstance, ValidationError } from '../types/Validation';
import ValidationMethods from './validation-methods';
import ValidationMessages from './validation-messages';

export default function (params: {
  computer: any;
  content: any,
  validation: ValidationInstance[],
}): ValidationError[] {
  const { content, validation, computer } = params;

  /**
   * If there is no validation instances, there's no need to try and
   * validate anything.
   */
  if (!validation) return [];

  /**
   * Filter through our validation instances that have errors, and then
   * add these to be an array of @param ValidationError
   */
  const errors: ValidationError[] = [];

  validation.forEach((instance) => {
    let fieldContent = content;

    if (instance.formula) {
      const [result] = computer.compute([instance.formula]);
      fieldContent = result.value;
    }

    const isValid = ValidationMethods[instance.type]({
      validation: instance,
      content: fieldContent,
    });

    if (!isValid) {
      errors.push({
        level: instance.level,
        message: instance.message
          || ValidationMessages[instance.type]({ validation: instance, content: fieldContent }),
      });
    }
  });

  return errors;
}
